import PageHero from "../components/sections/PageHero";
import ContactUs from "../components/sections/ContactUs";
import ScrollReveal from "components/common/ScrollReveal";
import SectionHeading from "components/common/SectionHeading";
import DataCenter from "assets/images/Data-Center.svg";
import Cybersecurity from "assets/images/cybersecurity.svg";
import DataAnalysis from "assets/images/data-analysis.svg";
import ArtificialIntelligence from "assets/images/Artificial-Intelligence.svg";

const CORE_SERVICES = [
    {
        image: DataCenter,
        title: "Managed Services",
        description:
            "Comprehensive IT management and support to keep your business running smoothly. We handle everything from infrastructure maintenance to help desk support.",
    },
    {
        image: DataAnalysis,
        title: "Cloud Solutions",
        description:
            "Expert cloud migration, optimization, and management services. We help you leverage the power of cloud computing to enhance scalability and efficiency.",
    },
    {
        image: Cybersecurity,
        title: "Cybersecurity",
        description:
            "Advanced security solutions to protect your digital assets. Our comprehensive security services include threat detection, prevention, and incident response.",
    },
    {
        image: DataAnalysis,
        title: "Data Governance",
        description:
            "Robust data management and compliance solutions. We ensure your organization meets regulatory requirements while maximizing data value.",
    },
    {
        image: ArtificialIntelligence,
        title: "Digital Transformation",
        description:
            "Strategic guidance and implementation services to modernize your business. We help organizations embrace digital technologies and stay competitive.",
    },
    {
        image: Cybersecurity,
        title: "Compliance",
        description:
            "Expert guidance on industry regulations and standards. We help ensure your IT infrastructure meets all necessary compliance requirements.",
    },
];

const WHY_CHOOSE = [
    "20+ Years Experience",
    "Certified IT Professionals",
    "24/7 Support",
    "Industry-Leading Solutions",
];

const OurCompany = () => {
    return (
        <>
            <PageHero
                subtitle="Our Motivation"
                title={
                    <>
                        Let&apos;s get <span className="text-primary">IT</span>{" "}
                        done.
                    </>
                }
                body="We strive to deliver excellence to our customers and colleagues. Our values are the cornerstone of all our actions and decisions."
            />

            <section>
                <div className="container max-w-3xl text-center">
                    <ScrollReveal variant="up">
                        <SectionHeading
                            eyebrow="Our Story"
                            title="Our Company"
                            description="We are a premier IT solutions provider with over 20 years of industry expertise. Our team of seasoned professionals delivers comprehensive technology solutions that drive business growth and innovation."
                        />
                    </ScrollReveal>
                </div>
            </section>

            <section className="light-bg">
                <div className="container max-w-3xl">
                    <ScrollReveal variant="up">
                        <SectionHeading
                            title="Why choose us?"
                            align="center"
                            className="mb-10"
                        />
                        <div className="grid sm:grid-cols-2 gap-4">
                            {WHY_CHOOSE.map((item) => (
                                <div
                                    key={item}
                                    className="flex items-center gap-3 p-4 rounded-xl bg-white border border-gray-100 shadow-sm"
                                >
                                    <span className="w-2 h-2 rounded-full bg-primary shrink-0" />
                                    <span className="text-secondary/80">
                                        {item}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </ScrollReveal>
                </div>
            </section>

            <section>
                <div className="container">
                    <SectionHeading
                        eyebrow="Capabilities"
                        title="Our Core Services"
                        description="End-to-end IT solutions tailored to enterprise needs."
                    />
                    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
                        {CORE_SERVICES.map((service, index) => (
                            <ScrollReveal
                                key={service.title}
                                variant="up"
                                delay={index * 80}
                            >
                                <div className="service-card group h-full">
                                    <div className="service-card-image">
                                        <img
                                            src={service.image}
                                            alt={service.title}
                                        />
                                    </div>
                                    <h3 className="text-lg font-bold text-black mb-3">
                                        {service.title}
                                    </h3>
                                    <p className="text-sm text-secondary/70 leading-relaxed">
                                        {service.description}
                                    </p>
                                </div>
                            </ScrollReveal>
                        ))}
                    </div>
                </div>
            </section>

            <ContactUs />
        </>
    );
};

export default OurCompany;
